import Service, { service } from '@ember/service'
import type Store from '@ember-data/store'
import type { IntlService } from 'ember-intl'
import type SessionService from 'teacher-ui-client/services/session'
import type FlashQueueService from 'teacher-ui-client/services/flash-queue'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import type SubscriptionTypeService from 'teacher-ui-client/services/subscription-type'
import type SubscriptionUtilisation from 'teacher-ui-client/models/subscription-utilisation'

export default class SubscriptionUtilisationService extends Service {
  @service store!: Store

  @service flashQueue!: FlashQueueService

  @service intl!: IntlService

  @service session!: SessionService

  @service subscriptionType!: SubscriptionTypeService

  /**
   * Fetches all subscription utilisations for the current teacher (adapter scopes the endpoint by teacher)
   */
  async fetchAll() {
    await this.store.query<SubscriptionUtilisation>('subscription-utilisation', {
      // @ts-expect-error - include types not correct
      include: ['teacher-subscription', 'teacher-subscription.teacher', 'school-subscription'].join(','),
    })
    return this.store.peekAll<SubscriptionUtilisation>('subscription-utilisation')
  }

  showOverCapacityFlash(subscriptionType: SubscriptionType) {
    const record = this.store
      .peekAll<SubscriptionUtilisation>('subscription-utilisation')
      .find((util) => util.subscriptionType === subscriptionType)

    if (record?.isOverCapacity) {
      const isSubco = subscriptionType && this.session.currentTeacher.subcoFor(subscriptionType)
      if (isSubco) {
        this.flashQueue.addCaution({
          subtitle: this.intl.t('manage.overCapacityMessageSubco'),
        })
      } else if (this.subscriptionType.currentSubco) {
        this.flashQueue.addCaution({
          subtitle: this.intl.t('manage.overCapacityMessage'),
        })
      } else {
        this.flashQueue.addCaution({
          subtitle: this.intl.t('manage.overCapacityMessageNoSubco'),
        })
      }
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    'subscription-utilisation': SubscriptionUtilisationService
  }
}
